import {
  FormControl,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import 'dayjs/locale/en-gb';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCustomFrameworks, selectStandardFrameworks } from '../redux/reducers/frameworkReducer';

function FrameworkSelector({ handleFrameworkChange, frameworkId = '', disabled = false }) {
  const { t } = useTranslation();
  const [showSelect, setShowSelect] = useState(false);
  const standardFrameworks = useSelector(selectStandardFrameworks);
  const customFrameworks = useSelector(selectCustomFrameworks);
  const [selectedFramework, setSelected] = useState(frameworkId);

  const handleChange = (event) => {
    const { value } = event.target;
    setSelected(value);
    handleFrameworkChange(value);
    setShowSelect(false);
  };

  function findTitle(id) {
    return (standardFrameworks.find((fw) => fw.id === id)?.title
      ?? customFrameworks.find((fw) => fw.id === id)?.title
      ?? '?'
    );
  }

  useEffect(() => {
    setSelected(frameworkId);
  }, [frameworkId]);

  return (
    <FormControl>
      <InputLabel shrink sx={{ px: 1, backgroundColor: 'white' }} htmlFor="label">
        {t('activity.modal.framework')}
      </InputLabel>
      <Select
        displayEmpty
        value={selectedFramework}
        variant="outlined"
        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
        open={showSelect}
        disabled={disabled}
        onOpen={() => setShowSelect(true)}
        onClose={() => setShowSelect(false)}
        renderValue={(selected) => (
          selected !== '' ? (
            <Typography variant="bold">{findTitle(selected)}</Typography>
          ) : (
            <Typography variant="regular">{t('framework.selectFramework')}</Typography>
          ))}
        onChange={handleChange}
      >
        <ListSubheader>{t('framework.standard')}</ListSubheader>
        {standardFrameworks.map((framework) => (
          <MenuItem id={framework.title} key={framework.id} value={framework.id}>
            <ListItemText>
              <Typography variant="bold">{framework.title}</Typography>
            </ListItemText>
          </MenuItem>
        ))}
        {customFrameworks.length > 0 && <ListSubheader>{t('framework.custom')}</ListSubheader>}
        {customFrameworks.map((framework) => (
          <MenuItem id={framework.title} key={framework.id} value={framework.id}>
            <ListItemText>
              <Typography variant="bold">{framework.title}</Typography>
            </ListItemText>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default FrameworkSelector;
